// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TBKgH","type":"styles_type__iNkRn","choices":"styles_choices__ubjXH"};